import 'babel-polyfill'
import 'whatwg-fetch'

import React from 'react'
import ReactDOM from 'react-dom'
import createBrowserHistory from 'history/lib/createBrowserHistory'
import { useRouterHistory } from 'react-router'
import { syncHistoryWithStore } from 'react-router-redux'
import moment from 'moment'
import local from 'store'

import Root from 'internal-components/src/containers/Root'
import { loaded } from 'internal-components/src/redux/modules/meta'
import Sso from 'internal-components/src/api/sso'

import Invocation from './api/Invocation'
import makeRoutes from './routes'
import configureStore from './redux/configureStore'
import configureErrorHandling from './errors'
import * as utils from './utils'

moment.locale('en-au')

const appConfig = window.appConfig || {}
const version = document.body.getAttribute('data-version')
const appEl = document.getElementById('root')

const squareScript = document.createElement('script');
squareScript.src = SQUARE_JS;
document.head.appendChild(squareScript);
window.squarePayments = new Promise((resolve) => {
  const interval = setInterval(() => {
    if (window.Square) {
      clearInterval(interval);
      resolve(window.Square.payments(SQUARE_APPLICATION_ID, SQUARE_LOCATION_ID));
    }
  }, 100);
});


const errorHandler = configureErrorHandling(
  appEl,
  window,
  appConfig.ravenDsn || RAVEN_DSN,
  version,
)

const browserHistory = useRouterHistory(createBrowserHistory)({
  basename: __BASENAME__,
})

const getHref = (full = true) =>
  full ? window.location.href : window.location.pathname
const setHref = href => {
  window.location.href = href
}

const invocation = new Invocation(
  appConfig.invocationApi || INVOCATION_ENDPOINT_API,
  window.raven,
)
const sso = new Sso(
  appConfig.ssoApi || OAUTH_ENDPOINT_API,
  appConfig.ssoAuthEndpoint || OAUTH_ENDPOINT_AUTHENTICATE,
  appConfig.ssoLogout || OAUTH_ENDPOINT_LOGOUT,
)

const store = configureStore(invocation, sso, {
  autocompleteDelay: 500,
  debug: __DEBUG__ || local.get('infinite-debug'),
  errorHandler,
  eCryptKey: appConfig.ecryptKey || ECRYPT_KEY,
  getHref,
  history: browserHistory,
  init: false,
  raven: window.raven,
  sessionTimeout: 60 * 60 * 1000,
  setHref,
})

utils.activity(store, window)
utils.saveAuth(store, local)
utils.saveSignups(store, local)
utils.authLoad(store, local)
utils.loadKnownSignups(store, local)

const history = syncHistoryWithStore(browserHistory, store, {
  selectLocationState: state => state.router,
})

const routes = makeRoutes(store)

store.dispatch(loaded())

ReactDOM.render(
  <Root history={history} routes={routes} store={store} version={version} />,
  appEl,
)

/* eslint-disable no-underscore-dangle */
// Expose redux and local on the window object for debugging.
window._redux = store
window._local = local
/* eslint-enable no-underscore-dangle */



// WEBPACK FOOTER //
// ./src/main.jsx